// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__xwRkH","label":"LabeledBox_label__bF39r"};